import { useCallback, useEffect, useRef, useState } from "react";

export const CODE_TTL_MS = 5 * 60 * 1000;

const formatTime = (ms) => {
  const totalSeconds = Math.max(0, Math.ceil(ms / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${String(seconds).padStart(2, "0")}`;
};

const useExpirationTimer = (active, ttlMs = CODE_TTL_MS) => {
  const [remainingMs, setRemainingMs] = useState(ttlMs);
  const startedAtRef = useRef(null);

  const restart = useCallback(() => {
    startedAtRef.current = Date.now();
    setRemainingMs(ttlMs);
  }, [ttlMs]);

  useEffect(() => {
    if (!active) {
      startedAtRef.current = null;
      setRemainingMs(ttlMs);
      return undefined;
    }

    if (!startedAtRef.current) {
      startedAtRef.current = Date.now();
    }

    const tick = () => {
      const elapsed = Date.now() - startedAtRef.current;
      const next = Math.max(0, ttlMs - elapsed);
      setRemainingMs((prev) => (prev === next ? prev : next));
    };

    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [active, ttlMs]);

  return {
    remainingMs,
    formattedTime: formatTime(remainingMs),
    isExpired: remainingMs <= 0,
    restart,
  };
};

export default useExpirationTimer;
